export default {"src":"/_next/static/media/roy-morgan-award-2022.0238510c.svg","height":439,"width":349};